import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface ShareClickedPayload extends EventPayload {
  game: {
    playTime: number;
  };
  content: {
    title: string;
  };
}

const ShareClickedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.lowPoly,
  eventName: "Share Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createShareClickedPageEventPayload =
  eventPagePayloadCreator<ShareClickedPayload>(ShareClickedAnalyticsEvent);
